// S9 — RUSSIAN for terminology settings (`onboarding.terminology.*`).
//
// This is the screen where a tenant renames the 61 canonical terms, so the copy
// itself must not smuggle in vocabulary the tenant is about to change: it talks
// about «слово»/«название» and interpolates {{term}}, never naming an entity.
// The 61 term labels are NOT here — they are `onboarding.terms.*`, which the ru
// dictionary fills from TERMINOLOGY_BASE.ru.

import type { Translated } from "../../../../i18n-shape.js";
import type { terminologySettingsEn } from "./terminology.i18n.js";

export const terminologySettingsRu: Translated<typeof terminologySettingsEn> = {
  title: "Терминология",
  subtitle: "Как на вашем заводе называют вещи. Новое название меняется везде.",
  loading: "Загружается ваша терминология…",
  errorTitle: "Не удалось загрузить вашу терминологию",
  errorDetail: "Список терминов прочитать не удалось. Попробуйте ещё раз.",
  emptyTitle: "Показывать нечего",
  emptyBody: "Под ваш поиск ничего не подходит. Сбросьте фильтры, чтобы увидеть все термины.",
  emptyCta: "Сбросить фильтры",
  noTermsTitle: "Терминология не настроена",
  noTermsBody:
    "Для вашего предприятия пока не заведено ни одного термина. Попробуйте ещё раз или обратитесь к своему контакту в Assessly.",
  readOnlyNote:
    "Переименовывать термины может только администратор группы. Читать все значения можете и вы.",

  layerNote:
    "Каждое значение — это тот слой, который побеждает: сначала ваша формулировка, затем формулировка отраслевого пакета, затем стандартное название.",
  resetNote:
    "Сброс убирает вашу формулировку и возвращает стандартное название. Формулировка пакета вернётся при следующей установке.",

  searchLabel: "Поиск терминов",
  searchPlaceholder: "Термин или слово, которым вы пользуетесь…",
  sourceLabel: "Показать",
  source: {
    all: "Всё",
    overridden: "Только переименованное мной",
    tenant: "Переименовано нами",
    pack: "Из нашего отраслевого пакета",
    base: "Стандартное название",
  },
  stats: "Терминов: {{terms}} · переименовано вами: {{overridden}}",
  pageRange: "Термины {{from}}–{{to}} из {{total}}",
  prevPage: "Предыдущая страница",
  nextPage: "Следующая страница",
  clear: "Сбросить фильтры",

  colTerm: "Термин",
  colLocale: {
    en: "Английский",
    ru: "Русский",
    zh: "Китайский",
    fr: "Французский",
  },
  sourceBadge: {
    tenant: "Наше",
    pack: "Пакет",
    base: "Стандарт",
  },
  sourceTitle: {
    tenant: "Ваша собственная формулировка этого термина.",
    pack: "Поставляется вашим отраслевым пакетом.",
    base: "Стандартное название Assessly.",
  },
  cellLoading: "Загружается…",
  cellMissing: "Не загружено",

  edit: "Переименовать",
  editLabel: "{{term}} — {{locale}}",
  save: "Сохранить",
  saving: "Сохраняется…",
  cancel: "Отмена",
  reset: "Сбросить",
  resetting: "Сбрасывается…",
  charCount: "{{used}} из {{max}} символов",
  errorEmpty: "Введите слово — термин не может быть пустым.",
  errorTooLong: "Уложитесь в {{max}} символов.",
  saveFailed: "Не удалось сохранить переименование. Попробуйте ещё раз.",
  resetFailed: "Не удалось сбросить этот термин. Попробуйте ещё раз.",
  savedTenant: "Сохранено — теперь это ваша формулировка.",
  resetToBase: "Сброшено — термин снова показывает стандартное название.",
  resetToPack: "Сброшено — термин снова показывает формулировку вашего отраслевого пакета.",

  overwritePackCaution:
    "Эта формулировка пришла из вашего отраслевого пакета. Сохранение заменит её, и «Сбросить» вернёт затем стандартную формулировку, а не пакетную.",
  resetConfirmTitle: "Сбросить эту формулировку?",
  resetConfirmBody:
    "«{{label}}» ({{term}}, {{locale}}) вернётся к формулировке нижнего слоя. Отсюда это не отменить.",
};
